import React from 'react';

export function createPureComponent<P>(name: string, pureRender: React.SFC<P>) {
  class Pure extends React.PureComponent<P> {
    render() {
      return pureRender(this.props);
    }
  }
  if (process.env.NODE_ENV !== 'production') {
    (Pure as any).displayName = name;
  }
  return Pure;
}



// WEBPACK FOOTER //
// ./src/module/Common/utils/createPureComponent.ts